import type { AppRedirect } from '#src/shared/routes';

// The angles page moved from `/start-a-petition/social/:token` to `/social/:token/angles`.
// Product confirmed the old URL is actively being shared, so the legacy path needs to
// keep working — emit a permanent redirect so existing share links land on the new route.
export const REDIRECTS: readonly AppRedirect[] = [
	{
		path: '/start-a-petition/social/:token',
		buildUrl: ({ params: { token = '' }, queryString }) => `/social/${token}/angles${queryString}`,
		reason: 'social-starter-angles-url-moved',
		permanent: true,
	},
];
